import { Component, output } from '@angular/core';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { NgOptimizedImage } from '@angular/common';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { TooltipTriggerDirective } from '@group24ag/flowkit';

@Component({
  selector: 'app-flowpilot-window-header',
  imports: [FaIconComponent, NgOptimizedImage, TooltipTriggerDirective],
  template: `
    <div class="flex w-full items-center justify-between py-0.5 select-none">
      <div class="flex items-center gap-x-2">
        <img
          ngSrc="assets/images/icons/flow-pilot/gradient-F.svg"
          alt=""
          height="18"
          width="18"
          class="shrink-0"
          style="filter: brightness(0) invert(1);" />

        <span class="font-medium text-white">Flow Pilot</span>
      </div>

      <button
        flkTooltipTrigger
        class="cursor-pointer rounded p-1 leading-none transition-colors duration-150 hover:bg-white/20"
        tooltip="Collapse Flow Pilot"
        (click)="collapseWindow.emit()"
        (mousedown)="$event.stopPropagation()">
        <fa-icon class="text-dune-0" [icon]="['fas', 'xmark']" />
      </button>
    </div>
  `,
})
export class FlowWindowHeaderComponent {
  /** OUTPUTS **/
  /****/
  readonly collapseWindow = output<void>();

  constructor(library: FaIconLibrary) {
    library.addIcons(faXmark);
  }
}
